import { useState } from 'react';

import { consultationApi, useConsultations } from '@entities/consultations';
import type { AxiosError} from 'axios';
import { isAxiosError } from 'axios';

import { xhr } from '@shared/config';
import type { PaginatedList } from '@shared/types/common';
import type { Consultation } from '@shared/types/consultations';

export const useInfiniteList = (params: any) => {
	const [loading, setLoading] = useState(false);
	const [hasNextPage, setHasNextPage] = useState(true);
	const [error, setError] = useState<AxiosError>();
	const [page, setPage] = useState(1);
	const [items, setItems] = useState<number[]>([]);

	const { addConsultations } = useConsultations();

	const loadMore = async () => {
		setLoading(true);
		try {
			const res = await xhr.get<PaginatedList<Consultation>>(consultationApi, {
				params: {
					...params,
					page: page,
				},
			});

			if (!res.data) throw res;

			const { data } = res;
			addConsultations(data.results);
			const consultations = data.results.map((cons) => cons.id);
			setItems((p) => [...p, ...consultations]);

			setHasNextPage(!!data.next);

			if (data.next) setPage((p) => p + 1);
		} catch (error) {
			if (isAxiosError(error)) setError(error);
		}
		setLoading(false);
	};

	return {
		loading,
		items,
		hasNextPage,
		error,
		loadMore,
	};
};
